import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  Renderer2,
  ViewChild,
} from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { DOCUMENT } from "@angular/common";
import { ModalExitComponent } from "../shared/components/modal/modal-exit/modal-exit.component";
import { MatDialog } from "@angular/material/dialog";
import { Client } from "../models/client.model";
import { Subject } from "rxjs";
import { Store } from "@ngrx/store";

import {AppState} from "../store/app.state";

@Component({
  selector: "logged-user",
  templateUrl: "loggeduser.component.html",
  styleUrls: ["./loggeduser.component.scss"],
})
export class LoggedUserComponent implements OnInit {
  destroy$ = new Subject<void>();

  currentRoute: string;
  client: Client|undefined;
  langMenuOpened = false;
  userMenuOpened = false;

  selectedLanguage = "it";

  public urlLogo: string = "";

  @ViewChild("userWrapper", { static: true }) userWrapper!: ElementRef;
  @ViewChild("langMenu") langMenu!: ElementRef;
  @ViewChild("userMenu") userMenu!: ElementRef;
  @ViewChild("langWrapper", { static: true }) langWrapper!: ElementRef;

  constructor(
    private router: Router,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    private dialog: MatDialog,
    private store: Store<AppState>
  ) {
    this.currentRoute = this.router.url.split("/")[2];
    // this.router.events.subscribe((e) => {
    //   if (e instanceof NavigationEnd) {
    //     this.currentRoute = this.router.url.split("/")[2];
    //     // Vedere di rimettere
    //     //this.sidebarOpened = false;
    //     this.document.body.style.overflow = "auto";
    //   }
    // });
  }

  ngOnInit() {
    // const lang = localStorage.getItem("lang");
    // if (lang) {
    //   this.selectedLanguage = lang;
    // } else {
    //   this.selectedLanguage = "it";
    // }
    //
    // this.store
    //   .select(selectCompanyLogo)
    //   .pipe(takeUntil(this.destroy$))
    //   .subscribe((logo) => {
    //     if (logo) {
    //       this.urlLogo = logo.url;
    //     }
    //   });
    //
    // this.companyInfoService.loadCompany();
    //
    // this.companyInfoService
    //   .getCompanyInfo()
    //   .pipe(takeUntil(this.destroy$))
    //   .subscribe((ci) => {
    //     caches.delete("logo");
    //     this.client = ci;
    //
    //     if (!!this.client && !!this.client.logo) {
    //       this.urlLogo = this.client.logo.url;
    //     }
    //   });
    //
    // this.renderer.listen("window", "click", (e: MouseEvent) => {
    //   const target = e.target as HTMLElement;
    //   if (this.userMenuOpened) {
    //     const wrapper = this.userWrapper.nativeElement as HTMLDivElement;
    //     if (
    //       target !== this.userMenu.nativeElement &&
    //       target !== wrapper &&
    //       target.classList.contains("no-close-window") &&
    //       target.classList.contains("no-close")
    //     ) {
    //       this.userMenuOpened = false;
    //     }
    //   }
    //   if (this.langMenuOpened) {
    //     const wrapper = this.langWrapper.nativeElement as HTMLDivElement;
    //     if (
    //       target !== this.langMenu.nativeElement &&
    //       target !== wrapper &&
    //       !target.classList.contains("no-close-window-lang") &&
    //       !target.classList.contains("no-close-lang")
    //     ) {
    //       this.langMenuOpened = false;
    //     }
    //   }
    // });
  }


  // openLangMenu($event): void {
  //   if (this.langMenu) {
  //     if (
  //       $event.target !== this.langMenu.nativeElement &&
  //       !$event.target.classList.contains("no-close-lang")
  //     ) {
  //       this.langMenuOpened = !this.langMenuOpened;
  //     }
  //   } else {
  //     this.langMenuOpened = !this.langMenuOpened;
  //   }
  // }

  onLogout(): void {
    const dialogRef = this.dialog.open(ModalExitComponent, {
      width: "420px",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // this.store.dispatch(AuthActions.onLogout());
      }
    });
  }
}
